
export default {
  inject: ['direction', 'inList'],

  props: {
    tag: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      dir: this.direction ?? 'block',
      list: this.inList ?? false
    };
  }
};
